import Courses from "./courses";

export default Courses;
